// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "loyalty-cXxtE";
var _4 = "loyalty__gainedMiles-2_B0Y";
var _5 = "loyaltyV2-15FMy";
var _6 = "header-12B0s";
var _7 = "header__text-2mITK";
var _8 = "header__price-2ncQV";
var _9 = "main-22GhQ";
var _a = "loyalty__notAwardedText-1CRn3";
var _b = "loyalty__awardedInfo-OMK19";
var _c = "loyalty__buttons-uJf0x";
var _d = "loyalty__option-3lRHN";
var _e = "loyalty__option_name-1IP-j";
var _f = "loyalty__option_description-3vBW9";
var _10 = "linkCards_modal-22phB";
var _11 = "connect_modal-2H_Pk";
export { _1 as "__esModule", _2 as "mobile", _3 as "loyalty", _4 as "loyalty__gainedMiles", _5 as "loyaltyV2", _6 as "header", _7 as "header__text", _8 as "header__price", _9 as "main", _a as "loyalty__notAwardedText", _b as "loyalty__awardedInfo", _c as "loyalty__buttons", _d as "loyalty__option", _e as "loyalty__option_name", _f as "loyalty__option_description", _10 as "linkCards_modal", _11 as "connect_modal" }
export default { "__esModule": _1, "mobile": _2, "loyalty": _3, "loyalty__gainedMiles": _4, "loyaltyV2": _5, "header": _6, "header__text": _7, "header__price": _8, "main": _9, "loyalty__notAwardedText": _a, "loyalty__awardedInfo": _b, "loyalty__buttons": _c, "loyalty__option": _d, "loyalty__option_name": _e, "loyalty__option_description": _f, "linkCards_modal": _10, "connect_modal": _11 }
